/**
 * Zod v4 renamed ZodError.errors to ZodError.issues. honeypot-ui bundles its own zodResolver
 * which reads .errors, so validation breaks when using zod v4.
 *
 * This patch adds an .errors getter (aliasing .issues) onto the ZodError prototype so that
 * honeypot-ui's resolver keeps working whilst Honeypot still uses v3 of zod.
 *
 * We can't patch ZodError.prototype directly because in Zod v4 the thrown error's prototype
 * is an internal class, not the exported ZodError. Instead we trigger a real parse error,
 * catch it, and patch whatever prototype the thrown instance actually has.
 */
import { z } from 'zod';

try {
  z.string().min(1).parse('');
} catch (e) {
  const proto = Object.getPrototypeOf(e);
  if (!Object.getOwnPropertyDescriptor(proto, 'errors')) {
    Object.defineProperty(proto, 'errors', {
      get() {
        return this.issues;
      },
      configurable: true,
    });
  }
}
